/* import __COLOCATED_TEMPLATE__ from './score-distribution.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { CxBenchmarkGroup } from './types';

interface ScoreSegment {
  label: string;
  colorClass: string;
  yourWidth: number;
  peerWidth: number;
}

interface Signature {
  Args: {
    // TODO: Consume benchmarkGroup to derive segment widths once real data is available
    benchmarkGroup: CxBenchmarkGroup | undefined;
  };
}

export default class ScoreDistribution extends Component<Signature> {
  @service declare intl: IntlService;

  // TODO: Compute from real data — these are placeholder percentages
  get segments(): ScoreSegment[] {
    return [
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.score-distribution.score-1',
        ),
        colorClass: 'bg-vis-violet-20',
        yourWidth: 30,
        peerWidth: 25,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.score-distribution.score-2',
        ),
        colorClass: 'bg-vis-violet-40',
        yourWidth: 25,
        peerWidth: 22,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.score-distribution.score-3',
        ),
        colorClass: 'bg-vis-orange-70',
        yourWidth: 15,
        peerWidth: 18,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.score-distribution.score-4',
        ),
        colorClass: 'bg-vis-orange-50',
        yourWidth: 18,
        peerWidth: 20,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.score-distribution.score-5',
        ),
        colorClass: 'bg-vis-orange-30',
        yourWidth: 12,
        peerWidth: 15,
      },
    ];
  }

  get lastSegmentIndex(): number {
    return this.segments.length - 1;
  }

  get legendItems(): { label: string; colorClass: string }[] {
    return this.segments.map((segment) => ({
      label: segment.label,
      colorClass: segment.colorClass,
    }));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::CxBenchmarkPanel::ScoreDistribution': typeof ScoreDistribution;
    'reporting/bespoke/fin-performance/cx-benchmark-panel/score-distribution': typeof ScoreDistribution;
  }
}
